import { combineReducers } from "redux";

const initialState = (() => {
  try {
    const stored = localStorage.getItem("betsplace");
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
})();

const bets = (state = initialState, action) => {
  switch (action.type) {
    case "SET_BETS":
      return action.payload;
    default:
      return state;
  }
};

const Betslip = combineReducers({
  bets,
});

export default Betslip;
